const createCauseQuery = (causeId?: string) => {
  return `cause_id=${causeId}`;
};

export { createCauseQuery };
